import { useEffect } from 'react';

import { useSelectorAuthData } from '../auth';
import { DucsInitConfig } from '../config';
import {
    useSelectorDucsInitConfig,
    useSelectEnv
} from '../configuration';
import useScript from '../hooks/use-script';
import { InitDucsTypes } from './ducs.types';

export const useDucs = () => {
    const auth = useSelectorAuthData();
    const config: DucsInitConfig = useSelectorDucsInitConfig();
    const env = useSelectEnv();
    const status = useScript(config?.DUCSLibraryUrl || '');
    const initDucs = ({
        targetDom,
        selectedConfiguration
    }: InitDucsTypes) => {
        if (config) {
            const {
                DUCSCdnUrl,
                DUCSContentApiEndpoint,
                DUCSAuthenticationGatewayEndpoint
            } = config;

            try {
                return DUCSApplication.initialise(
                    targetDom, {
                        configuration: {
                            CdnBasePath: DUCSCdnUrl.substring(0, DUCSCdnUrl.lastIndexOf('/') + 1),
                            PagesCdnDirectoryPath: DUCSCdnUrl.substring(DUCSCdnUrl.lastIndexOf('/') + 1, DUCSCdnUrl.length),
                            ContentGatewayEndpoint: DUCSContentApiEndpoint,
                            AuthenticationGatewayEndpoint: DUCSAuthenticationGatewayEndpoint,
                            env
                        },
                        ...selectedConfiguration
                    }
                );
            } catch (error) {
                console.error(error);
            }
        }
    };

    useEffect(() => {
        if (auth?.token) {
            window.pppAppConfig = {};
            window.pppAppConfig.authToken = auth.token;
        }
    }, [auth?.token]);

    return {
        initDucs,
        status
    };
};
